export { default } from './CancelHoldBatchAction';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/CancelHoldBatchAction/index.js